import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ProductionMasters, TreeCompany } from '../../../../api/model';
import ErrorComponent from '../../../atoms/ErrorComponent';
import {
  ProductionConfirmationRequestAdd,
  ProductionConfirmationRequestEdit,
} from './ProductionConfirmationRequestEdit';
import ProductionConfirmationRequestList, {
  ProductionConfirmationRequestListHandler,
} from './ProductionConfirmationRequestList';

// 1:新規作成 2:確認依頼済み(回答待ち) 3:回答済み(すべての回答が出揃った状態) 4:転送済み 5:完了
export const ConfirmationRequestStatuses = {
  New: 1,
  Requested: 2,
  Replied: 3,
  Forwarded: 4,
  Completed: 5,
};

// 確認依頼カテゴリ(1:システム通知)
export const ConfirmationRequestCategories = {
  System: 1,
};

export interface ProductionConfirmationRequestsTabHandler {
  refresh: () => void;
}

interface Props {
  productionId: number;
  masters: ProductionMasters;
  companyTrees: TreeCompany[];
  editModeTabIndex: number | undefined;
  setEditable: (editing: boolean) => void;
}

/**
 * 確認依頼タブ
 */
const ProductionConfirmationRequestsTab = forwardRef<ProductionConfirmationRequestsTabHandler, Props>(
  ({ productionId, masters, companyTrees, editModeTabIndex, setEditable }: Props, ref) => {
    const refProductionConfirmationRequestList = useRef<ProductionConfirmationRequestListHandler>(null);

    // 表示更新処理ハンドラのエクスポート
    useImperativeHandle(ref, () => ({
      refresh: () => {
        refProductionConfirmationRequestList.current?.refresh();
      },
    }));

    const {
      confirmationRequestId: confirmationRequestIdParam,
      confirmationRequestDivisionId: confirmationRequestDivisionIdParam,
    } = useParams();

    const location = useLocation();
    const isEdit = location.pathname.match(/.+confirmation-request\/edit\/.+/) != null;
    const isView = location.pathname.match(/.+confirmation-request\/view\/.+/) != null;
    const isAdd = location.pathname.match(/.+confirmation-request\/add\/.+/) != null;

    if (isEdit || isView) {
      return confirmationRequestIdParam ? (
        <ProductionConfirmationRequestEdit
          productionId={productionId}
          confirmationRequestId={+confirmationRequestIdParam}
          isReadonly={isView}
          masters={masters}
          companyTrees={companyTrees}
        />
      ) : (
        <ErrorComponent error={null} />
      );
    }

    if (isAdd) {
      return confirmationRequestDivisionIdParam ? (
        <ProductionConfirmationRequestAdd
          productionId={productionId}
          confirmationRequestDivisionId={+confirmationRequestDivisionIdParam}
          masters={masters}
          companyTrees={companyTrees}
        />
      ) : (
        <ErrorComponent error={null} />
      );
    }

    return (
      <ProductionConfirmationRequestList
        productionId={productionId}
        editModeTabIndex={editModeTabIndex}
        setEditable={setEditable}
        ref={refProductionConfirmationRequestList}
      />
    );
  }
);

export default ProductionConfirmationRequestsTab;
